import { Store, AnyAction } from "redux";
import { RootState } from "../store/types";
import { TypeSchema, getTableName, findTable } from "common/generator/description";
import { setSelectedTableAction } from "../reducers/tables-state";
import { History } from "history";
import { getAppIDFromHistory } from "store/lib";
import { definedMap } from "@glideapps/ts-necessities";

export function subscribeTablesState(store: Store<RootState, AnyAction>, history: History) {
    let lastvalidSchema: TypeSchema | undefined;
    store.subscribe(() => {
        const state = store.getState();
        const appID = getAppIDFromHistory(history);
        if (appID === undefined) return;
        const app = state.apps[appID];
        if (app === "loading" || app === undefined) return;

        if (app.sourcePad.schema === lastvalidSchema) return;
        lastvalidSchema = app.sourcePad.schema;

        const { selectedTable } = state.tables;
        const currentTables = app.sourcePad.schema.tables;
        const foundTable = findTable(app.sourcePad.schema, selectedTable);
        if (foundTable === undefined) {
            const defaultTable = currentTables.find(t => !getTableName(t).isSpecial);
            store.dispatch(setSelectedTableAction(definedMap(defaultTable, getTableName)));
        }
    });
}
